const TOGGLE_MENU = 'TOGGLE_MENU';

export function toggleMenu() {
    return {
        type: TOGGLE_MENU,
    };
}


const initialState = {
    showMenu: false,
};

export default function MainMenu(state = initialState, action) {
    switch (action.type) {
        case TOGGLE_MENU:
            return {
                showMenu: !state.showMenu,
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/modules/MainMenu.js